// extracted by mini-css-extract-plugin
export var cardContainer = "_ps-0";
export var cardHeader = "_ps-2";
export var collapsedState = "_ps-3";
export var dragHandle = "_ps-5";
export var dragHandleIcon = "_ps-6";
export var dragging = "_ps-1";
export var titleArea = "_ps-4";